import * as React from 'react';
import icon from '../../assets/img/flags/arizona.svg';

export const Arizona = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
